<template>
  <div
    class="form-field"
    :class="{
      'empty-lbl': field.type !== FIELD.TYPE.GROUP && !field.lbl,
      'email-templates-field':
        field.id_name?.name == 'emails_email_templates_idb',
      hidden: !!hidden(field)
    }"
  >
    <div v-if="field.type === FIELD.TYPE.TXT">
      <span>
        {{ field.value }}
      </span>
    </div>
    <div v-else-if="field.type === FIELD.TYPE.COMMUNICATION && !hidden(field)">
      <contact-form
        :ref="field.name"
        :field="field"
        :model="form[field.name]"
        :options="field.option.value_type_list"
        :disabled-field="disabled(field)"
        class="detached-form"
        @save="$emit('save-form')"
      ></contact-form>
      <Button
        buttonSize="big"
        buttonColor="blue"
        buttonText="Добавить контакт"
        @click="addContact"
      />
    </div>
    <div
      v-else-if="field.type === FIELD.TYPE.DETAIL_EXPERIENCE && !hidden(field)"
    >
      <detail-experience-form
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field)"
        :date-format="datepicker.dateFormat"
        class="detached-form"
        @save="$emit('save-form')"
      ></detail-experience-form>
    </div>
    <div v-else-if="field.type === FIELD.TYPE.EDUCATION && !hidden(field)">
      <Education
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field)"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>
    <div v-else-if="field.type === FIELD.TYPE.RECOMENDATION && !hidden(field)">
      <Recomendation
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field)"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>
    <div v-else-if="field.type === FIELD.TYPE.LANGUAGE && !hidden(field)">
      <Language
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field)"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>

    <div v-else-if="field.type === FIELD.TYPE.QUALIFICATION && !hidden(field)">
      <Qualification
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field)"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>

    <div
      v-else-if="
        field.type === FIELD.TYPE.MULTIARRAY &&
        field.name == FIELD.ID.LANGUAGE_LEVEL &&
        !hidden(field)
      "
    >
      <LanguageForm
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name] || []"
        :disabled-field="disabled(field)"
        :is-popup="true"
        :parent-form="form"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>
    <div
      v-else-if="
        field.type === FIELD.TYPE.MULTIARRAY &&
        field.name == FIELD.ID.ANOTHER_WORK_PLACE &&
        !hidden(field)
      "
    >
      <AddressForm
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name] || []"
        :disabled-field="disabled(field)"
        :is-popup="true"
        :parent-form="form"
        class="detached-form"
        @save="$emit('save-form')"
        @reset-address="resetAddress"
      />
    </div>
    <Photo
      v-else-if="field.type === FIELD.TYPE.IMAGE && !hidden(field)"
      :disabled="disabled(field)"
      :field="field"
      :model="form[field.name]"
      :file="photo_file"
    ></Photo>

    <el-form-item
      v-else-if="field.type === FIELD.TYPE.GROUP && !hiddenAll(field.fields)"
      label=""
      :class="[
        'sub-fields',
        hasBoolField(field.fields),
        disabledClass(field),
        field.name == 'superjob_salary_group' ? 'salary_group' : ''
      ]"
      label-width="0px"
    >
      <template v-for="it in field.fields">
        <form-row
          v-if="!hidden(it)"
          :key="it.name"
          :field="it"
          :module="module"
          :class="subFieldClass(it)"
          :model="form[it.name]"
          :parentId="form.record || ''"
          :options="options[it.name]"
          :callback="callback"
          :field-size="fieldSize || (isPopup ? 'medium' : 'big')"
          :newLabel="it.lbl"
          :form="form"
          :noRequiredStar="noRequiredStar"
          :loading="fieldLoading"
          :parentenum="
            dynamicEnumField(it) && it.parentenum ? form[it.parentenum] : ''
          "
          :blocked="blocked[it.name]"
          :defaultFirstOption="defaultFirstOption"
          @update-documents-list="updateDocumentsList"
          :search-param="field.search_param ? form[field.search_param] : ''"
          @change-option="selectOption"
          @set-value="setValue"
        ></form-row>
      </template>
    </el-form-item>
    <!-- </div> -->
    <div v-else-if="!textType(field.type) && !hidden(field)">
      <!-- условие с префиксом для отступа чекбокса в вакансии, шаблоне (надо переделать и убрать префикс) -->
      <!-- <span
        v-if="
          field.type === FIELD.TYPE.BOOL &&
          prefixClass == 'vacancy' &&
          field.visual_type !== 'no-label'
        "
        class="el-form-item__label"
      >
        <br />
        <br />
      </span> -->

      <FormButtons
        v-if="!hidden(field) && field.type == 'button'"
        :buttons_menu="fillButtonIntent(field)"
        :topPanel="false"
        view-type="detail"
      ></FormButtons>
      <form-row
        v-else-if="!hidden(field)"
        :key="field.name"
        :field="field"
        :module="module"
        :width="labelWidth"
        :options="options[field.name]"
        :model="form[field.name]"
        :parentId="form.record || ''"
        :callback="callback"
        :form="form"
        :datepicker="datepicker"
        :visible-option-btn="visibleOptionBtn"
        :field-size="fieldSize || (isPopup ? 'medium' : 'big')"
        :loading="fieldLoading"
        :blocked="blocked[field.name]"
        :disabled="disabled"
        :noRequiredStar="noRequiredStar"
        :defaultFirstOption="defaultFirstOption"
        :search-param="field.search_param ? form[field.search_param] : ''"
        @add-new-option="addNewOption"
        :parentenum="
          dynamicEnumField(field) && field.parentenum
            ? form[field.parentenum]
            : ''
        "
        @change-option="selectOption"
        @update-documents-list="updateDocumentsList"
        @set-value="setValue"
      ></form-row>
      <Divider
        v-if="field.name == 'resume_format'"
        hasLine
        class="form-format__divider"
        dividerSize="16"
      />
      <div
        class="answer-responds"
        v-if="
          field.name === 'answer_responds' &&
          (!inviteAndRefuse.invite || !inviteAndRefuse.refuse)
        "
      >
        <span class="answer-responds__label">
          Автоответы не созданы. Для создания автоответа перейдите в профиль.
        </span>
        <Button
          class="answer-responds__button"
          buttonColor="blue"
          buttonText="Перейти в профиль"
          @click="goToProfile(userId)"
        />
      </div>
      <div class="answer-responds" v-else-if="field.name === 'mass_vacancy'">
        <span class="answer-responds__label fz-14 secondary">
          Откликнувшиеся кандидаты сразу попадают на этап “Добавлен”
        </span>
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'auto_answer_aspirant'"
      >
        <span class="answer-responds__label fz-14 secondary">
          Сразу после отклика соискатель получит автоматический ответ в чат и на
          почту
        </span>
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'auto_answer_aspirant_link'"
      >
        <span
          class="answer-responds__label fz-14 secondary"
          style="margin-top: 8px"
        >
          Адрес на сайт, где размещена анкета
        </span>
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'hide_company_name'"
      >
        <span class="answer-responds__label fz-14 secondary">
          Сделает вакансию анонимной
        </span>
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'free_call_tracking'"
      >
        <span class="answer-responds__label fz-14 secondary">
          Вы увидите пропущенные звонки и получите записи всех разговоров. А
          подменный номер защитит вас от спамеров
        </span>
      </div>

      <div class="answer-responds" v-else-if="field.name === 'get_responds'">
        <div v-if="+form.get_responds">
          <span class="fz-14 secondary">
            Сбор откликов возможен с даты создания публикации или с будущей
            даты.
          </span>
          <div class="answer-responds__date">
            <DatePicker
              :model="form.get_responds_date"
              :field="{ type: 'date', name: 'get_responds_date' }"
              :datepicker="datepicker"
              size="medium"
              :options="pickerOptions"
              @set-value="
                (name, val) => {
                  handleChangeDate(val);
                }
              "
            />
          </div>
        </div>
      </div>
    </div>
    <el-form-item
      v-else-if="textType(field.type) && !hidden(field) && !blocked[field.name]"
      :prop="field.name"
      class="textarea"
      :class="[isEmptyField(field, form[field.name]) ? 'is-empty-field' : '']"
    >
      <span
        class="el-form-item__label"
        :class="{
          'no-required-star':
            field.visual_type == 'no-required-star' || noRequiredStar
        }"
        :style="`line-height: ${
          fieldSize || (isPopup ? 'medium' : 'big') == 'big'
            ? 40
            : fieldSize || (isPopup ? 'medium' : 'big') == 'medium'
            ? 32
            : 24
        }px`"
      >
        {{ field.visual_type !== 'no-label' ? field.lbl : '' }}
        <p v-if="field.help && field.icon_help" class="help__text">
          ({{ field.help }})
        </p>
        <p v-if="field.required" class="required-star">*</p>
      </span>
      <Editor
        :key="updateKey"
        :mentions="field?.mentions"
        :name="field.name"
        :value="form[field.name] || form[item.name]"
        :placeholder="field.placeholder || ''"
        :disabled="disabled(field)"
        :min-length="Number(field.minlength)"
        :max-length="Number(field.maxlength)"
        @change="changeEditorText($event)"
        :class="{ 'email-form__editor': field.type == FIELD.TYPE.EMAIL_BODY }"
      />
      <div
        class="answer-responds"
        v-if="field.name === 'auto_answer_aspirant_text'"
      >
        <span
          class="answer-responds__label fz-14 secondary"
          style="margin-top: 8px"
          v-html="
            `Доступные тэги
          <br/>[myName] — имя рекрутера из профиля, а если оно не указано — email
          <br/>[personName] — имя кандидата, который получит сообщение
          <br/>[vacancy] — название вакансии
          <br/>[resume] — название должности из резюме
          <br/>[link] — ссылка на сайт из поля «Внешняя ссылка»`
          "
        >
        </span>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import { store } from '@/store';
import { BUTTON, FIELD } from '@/utils/constants';
import { dateToMs } from '@/utils/helpers';
import { form, mixin } from '@/utils/mixins';
import { FormItem } from 'element-ui';
import AddressForm from 'Elements/AddressForm/AddressForm';
import Button from 'Elements/Button/Button';
import ContactForm from 'Elements/ContactForm/ContactForm';
import DatePicker from 'Elements/DatePicker/DatePicker';
import DetailExperienceForm from 'Elements/DetailExperienceForm/DetailExperienceForm';
import Divider from 'Elements/Divider/Divider';
import Editor from 'Elements/Editor/Editor';
import Education from 'Elements/Education/Education';
import FormButtons from 'Elements/Form/FormButtons';
import Language from 'Elements/LanguageForm/Language';
import LanguageForm from 'Elements/LanguageForm/LanguageForm';
import Qualification from 'Elements/Qualification/Qualification';
import Recomendation from 'Elements/Recomendation/Recomendation';
import Photo from 'Elements/Upload/Photo';
import FormRow from './FormRow';

// import ExperienceJob from 'Elements/ExperienceJob/ExperienceJob';

export default {
  mixins: [mixin, form],
  props: {
    item: Object,
    form: Object,
    module: String,
    prefixClass: String,
    formSize: { type: String, default: 'mini' },
    fieldSize: { type: String, default: '' },
    isPopup: Boolean,
    labelWidth: String,
    datepicker: Object,
    contactOpts: Object,
    visibleOptionBtn: {
      type: Boolean,
      default: false
    },
    photo_file: Array,
    fieldLoading: Boolean,
    options: Object,
    blocked: Object,
    callback: Object,
    noRequiredStar: Boolean,
    defaultFirstOption: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      updateKey: 0,
      field: this.item,
      FIELD,
      BTN: BUTTON,
      userId: store.state.common.userId,
      defaultDate: null,
      pickerOptions: {
        disabledDate: this.rangeRespondsDate
      }
    };
  },
  created() {
    if (this.field.name === 'get_responds') {
      this.setDateRespond();
    }

    if (this.field?.internal) {
      for (const item in this.field.internal) {
        this.form[`internal-${item}`] = this.field.internal[item];
      }
    }
  },
  mounted() {
    if (this.item.name == 'about_oneself' && !this.form[this.field.name]) {
      this.updateKey++;
    }
  },
  computed: {
    inviteAndRefuse() {
      return store.state.vacancy.inviteAndRefuseText;
    }
  },
  methods: {
    goToProfile(userId) {
      this.$router.push(`/users/${userId}`);
    },
    fillButtonIntent(field) {
      const paramMap = {
        email_password: 'email_password',
        mail_smtppass: 'email_password',
        email_user: 'email_user',
        mail_from_name: 'outbound_email_smtp_from_name',
        mail_sendtype: 'email_protocol',
        mail_smtpport: 'outbound_email_mail_smtpport',
        mail_smtpuser: 'email_user',
        outboundtest_from_address: 'email_user',
        outboundtest_to_address: 'email_user',
        port: 'inbound_email_port',
        mail_smtpauth_req: 'outbound_email_mail_smtpauth_req',
        mail_smtpserver: 'outbound_email_mail_smtpserver',
        ssl_enabled: 'inbound_email_ssl_enabled',
        calendar_login: 'outlook_login',
        calendar_password: 'outlook_password',
        calendar_server: 'outlook_server',
        server_url:
          this.form.email_protocol === 'HTTPS'
            ? 'https_server'
            : 'inbound_email_server_url',
        mail_smtpssl: 'outbound_email_mail_smtpssl'
      };

      const result = JSON.parse(JSON.stringify(field));

      if (field?.intents[0]?.request?.request_params) {
        const params = field.intents[0].request.request_params;
        for (let key in params) {
          const mappedKey = paramMap[key];
          const formValue = this.form[mappedKey] || params[key] || '';

          result.intents[0].request.request_params[key] =
            mappedKey === 'outbound_email_mail_smtpssl' && key == 'ssl_enabled'
              ? formValue === '1'
                ? '/ssl'
                : ''
              : formValue;
        }
      }

      if (field?.intents[0]?.request?.dynamic_request_params) {
        const params = field.intents[0].request?.dynamic_request_params;
        for (let key in params) {
          const mappedKey = paramMap[key];
          const formValue = this.form[mappedKey] || params[key] || '';

          result.intents[0].request.dynamic_request_params[key] = formValue;
        }
      }

      return [[result]];
    },
    openOldPage(url) {
      this.$router.push({
        name: '*',
        params: {
          url: url
        }
      });
    },
    handleChangeDate(val) {
      this.$set(this.form, 'get_responds_date', val);

      if (dateToMs(this.defaultDate.toLocaleDateString()) < dateToMs(val)) {
        this.$set(this.form, 'nextDate', true);
      }
    },
    updateDocumentsList() {
      this.$emit('update-documents-list');
    },
    setDateRespond() {
      if (this.form.published_at) {
        const date =
          this.form?.get_responds == 1
            ? this.form?.get_responds_date
            : this.form?.published_at;

        this.defaultDate = this.getNewDate(date);
      } else {
        this.defaultDate = new Date();
      }
    },
    rangeRespondsDate(time) {
      const format = 'DD.MM.YYYY HH:mm';
      let date = this.form?.published_at
        ? this.rawDate(this.form.published_at, format)
        : new Date();
      date = new Date(date.setDate(date.getDate() - 1));
      return time.getTime() <= date;
    },
    disabledClass(field) {
      return this.disabled(field) ? 'sub-fields--disabled' : '';
    },
    subFieldClass(field) {
      const selectType = this.selectType(field.type);
      const className = selectType
        ? `el-select el-select--${this.formSize}`
        : `el-input el-input--${this.formSize}`;

      return [className /*this.disabled(field) ? 'is-disabled' : ''*/];
    },
    hasBoolField(fields) {
      return fields &&
        Array.isArray(fields) &&
        fields.find(item => item.type === FIELD.TYPE.BOOL)
        ? 'sub-fields--max'
        : '';
    },
    hiddenAll(fields) {
      return fields.every(field => this.hidden(field));
    },
    selectOption(...params) {
      this.$emit('change-option', ...params);
    },
    setValue(name, val, blocked, trigger) {
      this.$emit('set-value', name, val, blocked, trigger);

      if (name === 'get_responds' && val === '1') {
        const date = this.form?.published_at?.split(' ')[0] || null;
        const dateParts = date?.split('-');
        this.$set(
          this.form,
          'get_responds_date',
          (this.form?.published_at
            ? date.includes('-')
              ? `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`
              : date
            : '') ||
            this.formatDate(this.defaultDate, this.datepicker.dateFormat)
        );
      }
    },
    addNewOption(name) {
      this.$emit('add-new-option', name);
    },
    addContact() {
      store.commit('common/addContact', {
        opts: this.field.option.value_type_list
      });
    },
    changeEditorText(data) {
      this.setValue(this.field.name, data, this.field.blocked, true);
    },
    resetAddress() {
      this.$set(this.form, 'work_place', '');
    }
  },
  components: {
    'el-form-item': FormItem,
    FormRow,
    Editor,
    Photo,
    Button,
    ContactForm,
    DetailExperienceForm,
    Education,
    Language,
    Qualification,
    DatePicker,
    LanguageForm,
    Divider,
    FormButtons,
    AddressForm,
    Recomendation
    // ExperienceJob
  }
};
</script>

<style lang="scss">
.el-textarea__inner {
  &:hover {
    background-color: $black-10 !important;

    &:after {
      background-color: $black-10 !important;
    }
  }
}

.answer-responds {
  display: flex;
  flex-direction: column;

  &__date {
    width: 150px;
    margin-top: 2px;
  }

  &__label {
    font-size: 16px;
    line-height: 24px;
    color: $black-100;
    margin-bottom: 8px;
    word-break: break-word;
  }

  &__button {
    width: 171px;
  }
}

.sub-fields {
  &--max {
    .el-form-item:first-child {
      margin-right: 32px;
    }
  }

  & > .el-form-item__content {
    display: flex;

    & > .el-form-item {
      margin-bottom: 0;
    }

    & > .el-form-item:not(:first-child) {
      margin-left: 8px !important;
    }
  }
}

.salary_group {
  & > .el-form-item__content {
    & > .el-form-item:not(:first-child) {
      margin-left: 12px !important;
    }

    .row:first-child {
      width: 214px !important;
      margin-right: 12px;
    }

    .row:nth-child(2) {
      width: 214px !important;
      margin-right: 12px;
    }

    .row:last-child {
      width: 140px !important;
    }
  }
}

.el-form-item__label {
  color: $black-200;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;

  .help__text {
    display: inline;
    color: $black-80;
    margin-left: 4px;
  }

  .required-star {
    display: inline;
    color: $red;
  }
}
</style>

<style lang="scss" scoped>
.form-format__divider {
  margin-bottom: 16px;
}
.textarea {
  & ::v-deep .el-form-item__label {
    color: $black-200;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    display: flex;

    .help__text {
      display: inline;
      color: $black-80;
      margin-left: 4px;
    }
  }
}

.email-form__editor ::v-deep .ck-content {
  min-height: 144px;
}
</style>
